import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { ConfirmationModalComponent } from '../components/confirmation-modal/confirmation-modal.component';

@Directive({
  selector: '[appConfirmation]',
  host: {
    '(click)': '$event.stopPropagation(); openConfirmationModal()'
  },
  standalone: true
})
export class ConfirmationDirective {

  @Input() confirmButtonText = 'Yes'.trans('confirmation-modal/yes.Button');
  @Input() cancelButtonText = 'Cancel'.trans('confirmation-modal/cancel.Button');
  @Input() confirmationModalTitle = 'Confirmation'.trans('confirmation-modal/header/title');
  @Input() confirmationModalText = 'Are you sure you want to proceed?'.trans('confirmation-modal/body/text');
  @Input() namespace = 'confirmation';

  @Output() onConfirm = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();

  public openConfirmationModal(): void {
    ConfirmationModalComponent.instance.title = this.confirmationModalTitle;
    ConfirmationModalComponent.instance.text = this.confirmationModalText;
    ConfirmationModalComponent.instance.confirmButtonText = this.confirmButtonText;
    ConfirmationModalComponent.instance.cancelButtonText = this.cancelButtonText;
    ConfirmationModalComponent.instance.onConfirm = this.onConfirm;
    ConfirmationModalComponent.instance.onCancel = this.onCancel;
    ConfirmationModalComponent.instance.open();

    if (this.namespace) {
      ConfirmationModalComponent.instance.namespace = this.namespace;
    }
  }
}
